var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',_vm._g(_vm._b({attrs:{"loading":_vm.saving,"type":_vm.type,"block":"","icon":"check","shape":"round"},on:{"click":_vm.save}},'a-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }